module.exports = __webpack_public_path__ + "img/suzuki-jimny.c73fd275.jpg";